import React from "react";
import "./styles.module.scss";
import Header from "./header";
import Footer from "./footer";
import QuestionPage from "../../pages/questionPage";

const Layout = (props) => {
    return(
        <div>
            <Header />
                {props.children}
            <Footer />
        </div>
    )
}

export default Layout;